import Column from '@components/Column';
import styled from '@emotion/styled';

function ReceiptDivider() {
    return (
        <Divider fullWidth spacing={4}>
            <Line />
            <Line />
        </Divider>
    );
}

const Divider = styled(Column)`
    padding: 9px 0;
    width: 100%;
`;

const Line = styled.div`
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23DEE1E4' stroke-width='5' stroke-dasharray='6%2c 10' stroke-dashoffset='11' stroke-linecap='square'/%3e%3c/svg%3e");
    height: 2px;
    width: 100%;
`;

export default ReceiptDivider;
